import React from 'react';
import { TypographyVariant } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  header: {
    fontWeight: 700,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

interface Props {
  children: React.ReactNode;
  className?: string;
  variant?: TypographyVariant;
}

export default function Header({
  children,
  className = '',
  variant = 'h6',
}: Props) {
  const classes = useStyles();

  return (
    <Typography
      variant={variant as TypographyVariant}
      className={`${classes.header} ${className}`}
    >
      {children}
    </Typography>
  );
}
